import { render, staticRenderFns } from "./SettingsFormComponent.vue?vue&type=template&id=3e4ebe9f&scoped=true&"
import script from "./SettingsFormComponent.vue?vue&type=script&lang=js&"
export * from "./SettingsFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./SettingsFormComponent.vue?vue&type=style&index=0&id=3e4ebe9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4ebe9f",
  null
  
)

export default component.exports